<div #topDiv class="flex h-full flex-col bg-white">
  <pl-container *ngIf="showProgressSavedBannerToast()" @opacity class="">
    <div class="absolute right-2 top-5 flex h-16 items-center justify-between gap-4 rounded bg-pl-green-700 p-2.5">
      <p class="text-lg font-bold text-white">{{ 'utils.progress_saved' | translate }}</p>
      <pl-icon class="h-12 w-12 text-white" [name]="PlIcon.tick" [frame]="IconFrame.round" />
    </div>
  </pl-container>
  <div *ngIf="isStepLoading()" class="flex h-full w-full items-center justify-center">
    <pl-loader />
  </div>
  <div *ngIf="!isStepLoading()" class="relative h-full flex grow flex-col gap-4">
    <pl-container *ngIf="isStepLocked()" class="grow">
      <div class="py-10">
        <pl-icon-text
          [iconColor]="null"
          [iconFrame]="IconFrame.round"
          [icon]="PlIcon.lock"
          [text]="'step.locked.body' | translate"
          [buttonLabel]="'step.locked.resume_progress' | translate"
          [buttonVariant]="ButtonVariant.blue"
          [buttonHref]="participantCurrentStepUrl()"
          [buttonType]="ButtonType.state"
        />
      </div>
    </pl-container>
    <form
      *ngIf="form && !isStepLocked()"
      [formGroup]="form"
      #myForm="ngForm"
      class="flex grow h-full flex-col gap-8 py-4"
      plScrollToInvalidControlOnSubmit
    >
      <pl-container *ngIf="!customisations().hideBreadcrumbs || !customisations().hideStepTitle" class="block">
        <div class="flex flex-col gap-8">
          <h5
            *ngIf="!customisations().hideBreadcrumbs"
            [innerHTML]="stepData()?.breadcrumbs"
            class="px-4 uppercase text-pl-orange-800 md:px-0"
          ></h5>
          <h1 *ngIf="!customisations().hideStepTitle" class="px-4 md:px-0">
            {{ customStepTitle || stepData()?.name }}
          </h1>
        </div>
      </pl-container>

      <ng-container [formArrayName]="FormControlName.blocks">
        <ng-container *ngFor="let block of formArrayBlocks.controls; let index = index">
          <ng-container [ngSwitch]="block.value.element">
            <pl-container *ngIf="block.value.element !== BlockType.lifemap" class="block">
              <pl-block-audio *ngSwitchCase="BlockType.audio" [formControlName]="index + ''" />
              <pl-block-bar-chart *ngSwitchCase="BlockType.barChart" [formControlName]="index + ''" />
              <pl-block-button *ngSwitchCase="BlockType.button" [formControlName]="index + ''" />
              <pl-block-carousel *ngSwitchCase="BlockType.carousel" [formControlName]="index + ''" />
              <pl-block-container
                *ngSwitchCase="BlockType.container"
                [formControlName]="index + ''"
                [isDisabled]="isStepCompleted()"
              />
              <pl-block-checkbox
                *ngSwitchCase="BlockType.checkbox"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
              />
              <pl-block-feedback
                *ngSwitchCase="BlockType.feedback"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
              />
              <pl-block-gauge-chart *ngSwitchCase="BlockType.gaugeChart" [formControlName]="index + ''" />
              <pl-block-html *ngSwitchCase="BlockType.html" [formControlName]="index + ''" />
              <pl-block-icon-text *ngSwitchCase="BlockType.iconText" [formControlName]="index + ''" />
              <pl-block-lifeact
                *ngSwitchCase="BlockType.lifeAct"
                [formControlName]="index + ''"
                [timeFormat]="participantTimeFormat()"
              />
              <pl-block-life-changes *ngSwitchCase="BlockType.lifeChanges" [formControlName]="index + ''" />
              <pl-block-module-overview *ngSwitchCase="BlockType.moduleOverview" [formControlName]="index + ''" />
              <pl-block-radiobox
                *ngSwitchCase="BlockType.radiobox"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
              /><pl-block-spider-chart *ngSwitchCase="BlockType.spiderChart" [formControlName]="index + ''" />
              <pl-block-textarea
                *ngSwitchCase="BlockType.textarea"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
              />
              <pl-block-textbox
                *ngSwitchCase="BlockType.textbox"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
              />
              <pl-block-ul *ngSwitchCase="BlockType.ul" [formControlName]="index + ''" />
              <pl-block-via-survey
                *ngSwitchCase="BlockType.viaSurvey"
                [isDisabled]="isStepCompleted()"
                [formControlName]="index + ''"
                [versionBeforeProgram]="pageType === PageType.viaSurvey"
                [tokenSurvey]="tokenSurvey"
              />
              <pl-block-word-cloud *ngSwitchCase="BlockType.wordCloud" [formControlName]="index + ''" />
              <pl-block-video *ngSwitchCase="BlockType.video" [formControlName]="index + ''" />
            </pl-container>

            <div class="flex h-full w-full justify-center" *ngSwitchCase="BlockType.lifemap">
              <pl-block-lifemap
                class="h-full w-full max-w-lifemap focus:outline-none"
                [formControlName]="index + ''"
                [timeFormat]="participantTimeFormat()"
              />
            </div>

            <div *ngSwitchDefault>TODO type={{ block.value.element | json }}</div>
          </ng-container>
        </ng-container>

        <button #hiddenSubmitButtonForm type="submit" class="invisible"></button>
      </ng-container>
    </form>
    <div *ngIf="isStepSaving()" class="flex w-full items-center justify-center gap-4">
      <pl-loader />
      <p class="text-lg font-bold uppercase text-pl-orange-500">{{ 'utils.saving' | translate }}...</p>
    </div>
    <div
      *ngIf="
        showProgressHaveBeenSavedBottomBanner() ||
        (!customisations().hideSnackbar && (buttonLeftConfig() || buttonRightConfig()))
      "
    >
      <div
        *ngIf="showProgressHaveBeenSavedBottomBanner()"
        @opacity
        class="flex h-20 w-full justify-center rounded bg-pl-green-700 p-2.5"
      >
        <div class="flex w-full max-w-content items-center justify-between gap-8 px-4">
          <div
            class="pl-inner-html text-lg font-bold !text-white"
            [innerHTML]="stepData()?.congrats || ('utils.well_done_progress_saved' | translate)"
          ></div>
          <pl-icon class="h-12 w-12 min-w-[3rem] text-white" [name]="PlIcon.tick" [frame]="IconFrame.round" />
        </div>
      </div>
      <pl-bottom-navigation
        *ngIf="!customisations().hideSnackbar && (buttonLeftConfig() || buttonRightConfig())"
        [buttonLeft]="buttonLeftConfig()"
        [buttonRight]="buttonRightConfig()"
      ></pl-bottom-navigation>
    </div>
  </div>
</div>
